import { useState } from "react";
import { useParcelShopPostalCodeValidation } from "@components/store-locator/hooks/useParcelShopPostalCodeValidation";
import type {
    SearchResultLocation,
    StoreLocatorSearchControl,
} from "@components/store-locator/controller";
import type { ShippingMethodTypes } from "@features/checkout/types";

export const useCheckoutStoreLocatorSearch = (
    shippingMethodKey?: ShippingMethodTypes
): StoreLocatorSearchControl => {
    const [searchResult, setSearchResult] = useState<SearchResultLocation>();
    const searchValidation = useParcelShopPostalCodeValidation({
        searchResult,
        shippingMethodKey,
    });

    return { searchResult, setSearchResult, searchValidation };
};
